import React from "react"
import AnimateHeight from 'react-animate-height';

export const SaveCancelToolbar = ({
  onSave,
  onCancel,
  onExpandAll,
  onCollapseAll,
  hasChanges,
  isSaving,
  className,
  style,
  ...props
}) => {

  return <div
    className={`clearfix ${className || ''}`}
    style={{
      paddingLeft: '30px',
      paddingRight: '30px',
      transition: 'padding 200ms',
      ...style
    }}
  >
    <span>
      <span className="btn btn-link" onClick={onExpandAll}>Expand All</span> |
      <span className="btn btn-link" onClick={onCollapseAll}>Collapse All</span>
    </span>
    <span className="pull-right" style={{
      opacity: hasChanges ? 1 : 0,
      transition: 'opacity 200ms, max-height 200ms',
      maxHeight: hasChanges ? '100px' : '0px'
    }}>
      <button className={`btn btn-outline-secondary ${isSaving || !hasChanges ? 'disabled' : ''}`} onClick={onCancel}>Cancel</button>
      <button className={`btn btn-secondary control-spacer-left ${isSaving || !hasChanges ? 'disabled' : ''}`} onClick={onSave}>Save</button>
    </span>
  </div>

}
